import type { Theme } from '@mui/material';
import styled from 'styled-components';

/* -------------------------------------------------------------------------- */

export const TwoColumnLayout = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (min-width: 1024px) {
    flex-direction: row;
    height: calc(100vh - 140px);
    gap: 16px;

    .pdf-panel {
      flex: 2;
      min-width: 0;
      overflow-y: auto;
      background: ${({ theme }) => theme.palette.background.paper};
      border-radius: 8px;
    }

    .form-panel {
      flex: 3;
      min-width: 0;
      display: flex;
      flex-direction: column;
      background: transparent;
      border-radius: 8px;
    }
  }
`;

export const PdfWrapper = styled.div`
  height: 100%;
`;

export const ScrollForms = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;
`;

export const BottomControlsBar = styled.div<{ theme: Theme }>`
  position: sticky;
  bottom: 0;
  background: ${({ theme }) => theme.palette.background.paper};
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  padding: 12px 16px;
  z-index: 20;
  box-shadow: ${({ theme }) => `0 -4px 8px ${theme.shadows[1]}`};
`;

export const BottomControlsInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
